/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  bypassQuickAddColorOption();


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

function bypassQuickAddColorOption() {
  $('.product-grid .product-item .slideup > button').on('click', function(e) {
    $(this).parent().find('.form-quick-add .selector-wrapper[data-select-position="2"]').addClass('is-active');
  });

  $('body').on('click', '.form-quick-add .radio__legend-back', function(e) {
    $(this).closest('.form-quick-add').find('.selector-wrapper[data-select-position="1"]').removeClass('is-active');
    $(this).closest('.slideup').find('button').removeClass('is-hidden');

    if($(window).width() < 769) {
      $(this).closest('.slideup').removeClass("is-visible");
      $(this).closest('.product-item').find('.product-information').trigger('mouseover');
    }
  });

  $('.product-grid .product-item .quick-add-button').on('click', function(e) {
    setTimeout(() => {
      $(this).parent().find('.form-quick-add .selector-wrapper[data-select-position="2"]').addClass('is-active');
    }, 500);
  });

  if($(window).width() < 769) {
    $('body').on('click', '.form-quick-add .radio__legend-back', function(e) {
      //$(this).closest('.form-quick-add').find('.selector-wrapper[data-select-position="2"]').removeClass('is-active');
      $(this).closest('.product-item').find('.quick-add-button').removeClass('is-hidden');
    });

    $('.quick-add-button').on('click', function(e) {
      console.log('yeelel');
      setTimeout(() => {
        $(this).removeClass('is-hidden');
      }, 300);
    });
  }
}